import React, {
  Component,
  useState,
  useContext,
  useEffect,
  useRef,
} from "react";
import style from "./LeftNavigation.module.css";
import { Container } from "react-bootstrap";
import BasicControls from "./DesignerControls/BasicControls";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSearch,
  faChevronCircleRight,
  faChevronCircleLeft,
  faThumbtack,
} from "@fortawesome/free-solid-svg-icons";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import Drawer from "@material-ui/core/Drawer";
import { withStyles, makeStyles, useTheme } from "@material-ui/core/styles";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import List from "@material-ui/core/List";
import SearchControl from "./GlobalSearch/SearchControl";
import { AppContext } from "../../Resources/CanvasContextFile";
import ControlsNewLayout from "./DesignerControls/ControlsNewLayout";
import CommonFieldsLayout from "./DesignerControls/CommonFieldsLayout";
import { Fade } from "react-bootstrap";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import axios from "../../axios";
import DataObjects from "../LeftNavigation/DataObjects/DataObjects";
import CreatePageTemplate from "./PageTemplate/CreatePageTemplate";
import ControlTemplate from "./PageTemplate/ControlTemplate";
import ControlSet from "./ControlSet/ControlSet";
import { useTranslation } from "react-i18next";
import { useDispatch, addContexts, useSelector, updateContexts } from "../../Redux";
import Tooltip from "@material-ui/core/Tooltip";
import { fetchProcessModularData } from "./../../components/IFormDesignerLayout/RequestLogic";
import { GetStateFromData } from "../CustomHooks/CustomHooks";
// import appdesign from "../../../public/locales/ {window?.psh_configs?.selectedLanguage} /appdesign.css";

const drawerWidth = 240;

const LeftNavigation = (props) => {
  const translationStyles1=window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA";  
  const { t } = useTranslation(["styles", "translation"]);
  const [search, setSearch] = useState("");
  
  const [pinIconPlace, setPinIconPlace]=useState(0);
  
  const textInput = React.useRef(null);
  const useStyles = makeStyles((theme) => ({
    iconButtonWidth:{
     width:"68px !important"
    },
    root: {
      display: "flex",
    },
    appBar: {
      transition: theme.transitions.create(["margin", "width"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },
    appBarShift: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
      transition: theme.transitions.create(["margin", "width"], {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    menuButton: {
      marginRight: theme.spacing(2),
    },
    hide: {
      display: "none",
    },
    drawer: {
      width: drawerWidth,
      flexShrink: 0,
      zIndex: 1,
    },
    drawerPaper: {
      // width: drawerWidth,
      // marginLeft: '68px',
      // zIndex:0,
      boxShadow: "3px 3px 6px #00000029",
    },
    drawerHeader: {
      display: "flex",
      alignItems: "center",
      padding: theme.spacing(0, 1),
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
      justifyContent: "flex-end",
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      marginLeft: -drawerWidth,
    },
    contentShift: {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    },
    expandableDrawer: {
      "& > div": {
        position: "absolute",
        zIndex: "1",
        overflow: "hidden",
        height: "100%",

        // height:'auto',
      },
      "& .MuiDrawer-paperAnchorLeft": {
        // left:"0",
        // right:"auto"
        left: t("styles:leftVal"),
        right: t("styles:rightVal"),
        zIndex: 3,
      },
    },
    paper: {
      height: "auto",
    },
    tooltip: {
      maxWidth: "260px",
      // maxHeight: "96px",
      background: "#FFFFFF 0% 0% no-repeat padding-box",
      color: "black",
      border: "#70707075 1px solid",
      boxShadow: "0px 3px 6px #00000029",
      opacity: 1,
      fontSize: 12,
    },
    arrow: {
      "&:before": {
        border: "1px solid #70707075",
      },
      color: "white",
      fontSize: 15,
    },
  }));

  const classes = useStyles();
  const theme = useTheme();

  const defaultSelectedItem = "Controls";

  const contexts = GetStateFromData(props.containerId);

  const {
    updateJson,
    openDrawer,
    setOpenDrawer,
    drawerPinned,
    setDrawerPinned,
    propertyPinned,
    setOpenProperties,
    setToggleProperty,
    dataObjectsContent,
    currentMappedDO,
    setDataObjectsContent,
    sessionIdCurrent,
    microFrontendData,
    activePage,
    appId,
    processId,
    setfilteredDataObject,
    filteredDataObject,
    filteredDataObjectCopy,
  } = contexts?.contexts;

  const updatedComponentInFormState = updateJson?.updatedComponentInFormState;
  const removeAndUpdateComponentInFormState =
    updateJson?.removeAndUpdateComponentInFormState;

  

  const [selectedMenuItemState, setSelectedMenuItemState] = useState("");
  const [selectedMenuItemNameState, setSelectedMenuItemNameState] = useState("");
  

  const CommonFields = (
    <img
      src={require("../../Icons/LeftNavigation/CommonFields.svg").default}
      height="16"
      draggable="false"
      alt="Common Fields Icon"
    />
  );
  const Controls = (
    <img
      src={require("../../Icons/LeftNavigation/Controls.svg").default}
      height="16"
      draggable="false"
      alt="Controls Icon"
    />
  );
  const DataObject = (
    <img
      src={require("../../Icons/LeftNavigation/DataObjects.svg").default}
      height="16"
      draggable="false"
      alt="Data Objects Icon"
    />
  );
  const Templates = (
    <img
      src={require("../../Icons/LeftNavigation/Templates.svg").default}
      height="16"
      draggable="false"
      alt="Templates Icon"
    />
  );

  const [variant, setVariant] = useState("permanent");

  const menuItems = {
    "Common Fields": (
      <div className={style.squareIconWrap}> {CommonFields} </div>
    ),
    Controls: <div className={style.squareIconWrap}> {Controls} </div>,
    "Data Objects": <div className={style.squareIconWrap}> {DataObject} </div>,
    Templates: <div className={style.squareIconWrap}> {Templates} </div>,
  };

  const anchor = "left";

  const dispatch = useDispatch();

  const [pinned, setPinned] = useState(false);

  useEffect(() => {
    if(document.querySelector("#iforms_leftNav_sideBySide")?.getBoundingClientRect().right !== pinIconPlace) {
      setPinIconPlace( document.querySelector("#iforms_leftNav_sideBySide")?.getBoundingClientRect().right );
    }
  });

  
  


  useEffect(() => {
      if (pinned === true) {
        window.changeDrawer("open");
        if(document.querySelector("#pinBtnConditionalStyle_id svg")){
          document.querySelector("#pinBtnConditionalStyle_id svg").style.color ="rgb(0, 114, 198)";
          document.querySelector("#pinBtnConditionalStyle_id svg").style.border = "1px solid rgb(0, 114, 198)";
        }
        setDrawerPinned(true);
      setSelectedMenuItemState(getRequiredView("Controls"));

      }
      if (pinned === false) {
        if(document.querySelector("#pinBtnConditionalStyle_id svg")){
          document.querySelector("#pinBtnConditionalStyle_id svg").style.color = "rgb(242, 248, 252)";
          document.querySelector("#pinBtnConditionalStyle_id svg").style.border ="1px solid rgb(242, 248, 252)";
        }
        setDrawerPinned(false);
        window.changeDrawer("close");
      }
  }, [pinned]);

  const [paneOpened, setPaneOpened] = useState(false);

  var pinBtnConditionalStyle = {
    position: "fixed",
    transition: "width 1s cubic-bezier(0.46, 0.03, 0.52, 0.96) 0.5s",
    //  left:openDrawer?(330-(pinIconSize/2))+'px':(68-(pinIconSize/2))+'px',
    left: openDrawer ? t("styles:320pxLeft") : t("styles:58pxLeft"),
    right: openDrawer ? t("styles:320pxRight") : t("styles:58pxRight"),
    top: "calc( var(--app-height-form) * 0.50)",
    zIndex:4,
  };

  window.changeDrawer = (status,marvinCheck) => {
    if (status == "close" && pinned !== true) {
      if (document.getElementById("leftNavigation_search")) {
        document.getElementById("leftNavigation_search").style.width = "0px";
        document.getElementById("leftNavigation_search").style.border = "none";
      }
      if(document.getElementById("leftNavigation_container")?.style?.display){
        document.getElementById("leftNavigation_container").style.display = "none";
        // setPinIconPlace( document.querySelector("#iforms_leftNav_sideBySide")?.getBoundingClientRect().right );
      }
      if(document.getElementById("input_controls_search_appform")?.style){
        document.getElementById("input_controls_search_appform").style.display = "none";
      }
      if(document.getElementById("pinBtnConditionalStyle_id")?.style?.left){
        pinBtnConditionalStyle.left = t("styles:58pxLeft");
        pinBtnConditionalStyle.right = t("styles:58pxLeft");
        // document.getElementById("pinBtnConditionalStyle_id").style.left =  t("styles:58pxLeft");
        // document.getElementById("pinBtnConditionalStyle_id").style.right = t("styles:58pxRight");
      }
      window.leftNavigationPanelOpen = false;
      setPaneOpened(false);
    }
    else if (status == "open") {
      if (document.getElementById("leftNavigation_search")) {
        // document.getElementById("leftNavigation_search").style.width = "288px";
        document.getElementById("leftNavigation_search").style.width = "320px";
        document.getElementById("leftNavigation_search").style.border = "1px solid #C4C4C4";
      }
      if (document.getElementById("leftNavigation_container")) {
        document.getElementById("leftNavigation_container").style.display ="block";
      }
      if(document.getElementById("input_controls_search_appform")){
        document.getElementById("input_controls_search_appform").style.display = "block";
      }
      if (document.getElementById("pinBtnConditionalStyle_id")) {
        pinBtnConditionalStyle.left = t("styles:320pxLeft");
        pinBtnConditionalStyle.right = t("styles:320pxLeft");
        // document.getElementById("pinBtnConditionalStyle_id").style.left = t("styles:320pxLeft");
        // document.getElementById("pinBtnConditionalStyle_id").style.right = t("styles:320pxRight");
      }
      window.leftNavigationPanelOpen = false;
      setPaneOpened(true);
      if (marvinCheck) {
        setSelectedMenuItemNameState("Controls");
        setSelectedMenuItemState(getRequiredView("Controls",true));        
      } 
    } 
    else if (status === "pin") {
      document.getElementById("pinBtnConditionalStyle_id").title = t( `translation:${"Unpin_Controls"}`);
    } 
    else if (status === "unpin") {
    }
    else {
      if (document.getElementById("leftNavigation_container").style.display == "block" && pinned !== true)
        window.changeDrawer("close");
      else window.changeDrawer("open");
    }
  };

  const toggleDrawer = (event, anchor, open, itemName = "Controls") =>
    {
      if (
        event &&
        event.type === "keydown" &&
        (event.key === "Tab" || event.key === "Shift")
      ) {
        return;
      }
      if(event.code === "Escape" && !drawerPinned && open === "on"){
        window.changeDrawer("close")
        setSelectedMenuItemNameState("")
        return
      }
      //console.log('toggleDrawer = (anchor, open , itemName) :: ',anchor, open , itemName);
      // setOpenDrawer(open);
      if (open === "toggle") {
        // setOpenDrawer(!openDrawer);
        window.changeDrawer("toggle");
      } else if (open === "on") {
        // setOpenDrawer(true);
        //console.log('inside else part :: true');
        window.changeDrawer("open");
      } else if (open === "off") {
        // setOpenDrawer(false);
        //console.log('inside else part :: false');
        window.changeDrawer("close");
      }

      if (!propertyPinned) {
        props.setSelectedControl(null);
        setToggleProperty(false);
      }
      // if(openDrawer===false){
      setSelectedMenuItemNameState(itemName);
      setSelectedMenuItemState(getRequiredView(itemName));
    };

  const togglePinning = () => {
    if (openDrawer) {
      setDrawerPinned(!drawerPinned);
    } else {
      // alert('Select any option and then try pinning!');
      setSelectedMenuItemNameState(defaultSelectedItem);
      setSelectedMenuItemState(getRequiredView(defaultSelectedItem));
      // setOpenDrawer(true);
      window.changeDrawer("open");
    }
  };

  const [dataObjectsState, setDataObjectsState] = useState();

  function dfs(node, term, foundIDS) {
    // Implement your search functionality
    let isMatching =
      node.VariableName?.toLowerCase() &&
      node.VariableName?.toLowerCase().indexOf(term) > -1;
      
    if(isMatching && node.VariableName){
      foundIDS.push(node.VariableName?.toLowerCase());
    }

    if (Array.isArray(node.children)) {
      node.children.forEach((child) => {
        // const hasMatchingChild = dfs(child, term, foundIDS);
        if(!isMatching) dfs(child, term, foundIDS);
        // isMatching = isMatching || hasMatchingChild;
      });
    }
  }

  function filterDataByMatchedIds(data, matchedIDS) {
    const matchedIDSUpdated = matchedIDS.map((str) => str.toLowerCase());

    function filter(items) {
      return items
        .map((item) => {
          const isMatch = matchedIDSUpdated.some((matchedId) =>
            item.VariableName.toLowerCase().includes(matchedId)
          );
          const matchedIDSChildren = item.children ? filter(item.children) : [];
          if (isMatch) {
            return { ...item, children: item.children };
          }
          if (matchedIDSChildren.length > 0) {
            return { ...item, children: matchedIDSChildren };
          }
          return null;
        })
        .filter((item) => item !== null);
    }

    return filter(data);
  }

  function search1(term) {
    // We wrap data in an object to match the node shape
    const dataNode = {
      children: filteredDataObjectCopy,
    };

    const matchedIDS = [];
    // find all items IDs that matches our search (or their children does)
    dfs(dataNode, term, matchedIDS);

    // filter the original data so that only matching items (and their fathers if they have) are returned
    return filterDataByMatchedIds(filteredDataObjectCopy, matchedIDS);
  }

  useEffect(() => {
    setSearch("");
    if(selectedMenuItemNameState.length!==0){
      window.selectedMenuItemNameState_leftpane = selectedMenuItemNameState; 
    }
  }, [selectedMenuItemNameState]);

  useEffect(() => {
    if (selectedMenuItemNameState === "Data Objects") {
      if (dataObjectsContent.length) {
        // const filteredData = dataObjectsContent.filter((child)=>searchTree(child,search))

        setfilteredDataObject(search1(search.toLowerCase()));
        dispatch(updateContexts({name: "filteredDataObject",value: search1(search.toLowerCase()), key: props?.containerId}));
      }
    } else {
      setSelectedMenuItemState(getRequiredView(selectedMenuItemNameState));
    }
  }, [search, selectedMenuItemNameState]);

  useEffect(() => {
    if (selectedMenuItemNameState === "Data Objects") {
      setSelectedMenuItemState(getRequiredView(selectedMenuItemNameState));
    }
  }, [selectedMenuItemNameState, JSON.stringify(currentMappedDO), JSON.stringify(filteredDataObject), JSON.stringify(props?.currentMappedDO)]);
  
  const getRequiredView = (item_name, marvinCheck) => {
    if (item_name === "Common Fields") {
      return (
        <Fade in={true}>
          <CommonFieldsLayout
            containerId={props.containerId}
            setDragging={props.setDragging}
            handleDragging={props.handleDragging}
            createNewElement={props.createNewElement}
            on_drag={props.on_drag}
            formData={props.formData}
            selectedControl={props.selectedControl}
            showProperties={props.showProperties}
            hideProperties={props.hideProperties}
            applyChanges={(ev, saveOldObject) =>
              props.applyChanges(ev, saveOldObject)
            }
            changeUndoList={() => props.changeUndoList()}
            unDo={props.undo}
            handleUndo={props.handleUndo}
            handleRedo={props.handleRedo}
            reDo={props.redo}
            search={search}
          />
        </Fade>
      );
    } else if (item_name === "Controls") {
      // return <BasicControls setDragging={props.setDragging} handleDragging={props.handleDragging} createNewElement={props.createNewElement} on_drag={props.on_drag} formData={props.formData} selectedControl={props.selectedControl} showProperties={props.showProperties} hideProperties={props.hideProperties} applyChanges={(ev,saveOldObject)=>props.applyChanges(ev,saveOldObject)} changeUndoList={()=>props.changeUndoList()}  unDo={props.undo} handleUndo={props.handleUndo} handleRedo={props.handleRedo} reDo={props.redo}/>;
      return (
        <Fade in={true}>
          <ControlsNewLayout
            marvinCheck={marvinCheck}
            containerId={props.containerId}
            setDragging={props.setDragging}
            handleDragging={props.handleDragging}
            createNewElement={props.createNewElement}
            on_drag={props.on_drag}
            formData={props.formData}
            selectedControl={props.selectedControl}
            showProperties={props.showProperties}
            hideProperties={props.hideProperties}
            applyChanges={(ev, saveOldObject) =>
              props.applyChanges(ev, saveOldObject)
            }
            changeUndoList={() => props.changeUndoList()}
            unDo={props.undo}
            handleUndo={props.handleUndo}
            handleRedo={props.handleRedo}
            reDo={props.redo}
            search={search}
          />
          {/* <CreatePageTemplate /> */}
          {/* <ControlSet formData={props.formData}/>  */}
        </Fade>
      );
    } else if (item_name === "Data Objects") {
      //<ControlsNewLayout/>
      return (
        <div
        //  className={style.LeftNavigation}
        >
          {/* <BasicControls setDragging={props.setDragging} handleDragging={props.handleDragging} createNewElement={props.createNewElement} on_drag={props.on_drag} formData={props.formData} selectedControl={props.selectedControl} showProperties={props.showProperties} hideProperties={props.hideProperties} applyChanges={(ev,saveOldObject)=>props.applyChanges(ev,saveOldObject)} changeUndoList={()=>props.changeUndoList()}  unDo={props.undo} handleUndo={props.handleUndo} handleRedo={props.handleRedo} reDo={props.redo}/> */}
          <DataObjects
            data={dataObjectsState}
            createNewElement={props.createNewElement}
            appId={props.appId}
            containerId={props.containerId}
            setSearch={setSearch}
          />
        </div>
        // <DataObjects data={dataObjectsState}/>
      );
    } else if (item_name === "Templates") {
      return (
        <div className={style.LeftNavigation}>
          {/* <BasicControls setDragging={props.setDragging} handleDragging={props.handleDragging} createNewElement={props.createNewElement} on_drag={props.on_drag} formData={props.formData} selectedControl={props.selectedControl} showProperties={props.showProperties} hideProperties={props.hideProperties} applyChanges={(ev,saveOldObject)=>props.applyChanges(ev,saveOldObject)} changeUndoList={()=>props.changeUndoList()}  unDo={props.undo} handleUndo={props.handleUndo} handleRedo={props.handleRedo} reDo={props.redo}/> */}
          <ControlTemplate
            setDragging={props.setDragging}
            handleDragging={props.handleDragging}
            createNewElement={props.createNewElement}
            on_drag={props.on_drag}
            formData={props.formData}
            selectedControl={props.selectedControl}
            showProperties={props.showProperties}
            hideProperties={props.hideProperties}
            applyChanges={(ev, saveOldObject) =>
              props.applyChanges(ev, saveOldObject)
            }
            changeUndoList={() => props.changeUndoList()}
            unDo={props.undo}
            handleUndo={props.handleUndo}
            handleRedo={props.handleRedo}
            reDo={props.redo}
            containerId={props.containerId}
          />
        </div>
      );
    }
  };
  useEffect(()=>{
    document.getElementById("leftNavigation_container")?.focus();
    
   },[])
  function handleEscapeKey(e){
    // console.log("aa gaya mai1")
     if(e.code === "Escape" && !drawerPinned){
        window?.changeDrawer("close")
        setSelectedMenuItemNameState("");
     } 
 }

  const handleClickAway = (e) => {
    const insideLeftNav = e.target?.closest(`[id=leftNavigation_id_main]`);
    if (insideLeftNav === null) {
      textInput.current.value = "";
      // setfilteredDataObject(dataObjectsContent)
      window.changeDrawer("close");
      if (drawerPinned === false) {
        // setOpenDrawer(false);
        setSelectedMenuItemNameState("");
      }
    }
  };

  const squareIcon = <div className={style.squareIcon} />;

  var ITEMS = [];
  var divHeight = {};

  Object.keys(menuItems).forEach(function (key) {
    // //console.log('key :: ', key, 'menuItem Icon :: ',menuItems[key]);
    if (key !== undefined && key !== null && key.trim() !== "") {
    } else {
      // divHeight.height='34px';
      divHeight.paddingBottom = "9px";
    }
    ITEMS.push(
      <>
        <Tooltip
          title={t(`translation:${key} Tooltip Content`)}
          classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
          arrow
        >
          <IconButton
            onClick={(e) => toggleDrawer(e, anchor, "on", key)}
            onKeyDown={(e) => toggleDrawer(e, anchor, "on")}
            className={[style.ButtonLabel,translationStyles1? style.ButtonLabelTranslation:"",classes.iconButtonWidth].join(" ")}
            style={window?.psh_configs?.selectedLanguage==="ar" || window?.psh_configs?.selectedLanguage==="ar-SA" ?{marginRight:"0px !important"}:null}
          >
            <div
              className={
                selectedMenuItemNameState === key
                  ? style.selectedMenuItem
                  : style.menuItemsWrapper
              }
              style={divHeight}
            >
              {menuItems[key] !== undefined &&
                menuItems[key] !== null &&
                menuItems[key] !== "" && (
                  <div className={style.menuItemsIcon}>{menuItems[key]}</div>
                )}
              {key !== undefined && key !== null && key.trim() !== "" && (
                <div className={style.menuItemsLabel}>
                  <div className={style.labelWrapper}>
                    {/* {key} */}
                    {/* {t(key)} */}
                    {t(`translation:${key}`)}
                  </div>
                </div>
              )}
            </div>
          </IconButton>
        </Tooltip>
      </>
    );
  });

  var pinIconSize = 20;
  var pinIconStyle = {
    fontSize: pinIconSize + "px",
    color: drawerPinned ? "#0072C6" : "#F2F8FC",
    backgroundColor: drawerPinned ? "#FFFFFF" : "rgba(0,0,0,0.3)",
    boxShadow: "0px 3px 6px #00000029",
    opacity: 1,
    borderRadius: "50%",
    border: drawerPinned ? "1px solid #0072C6" : "1px solid #F2F8FC",
    padding: "1px",
    height: "20px"
  };

  // var pinBtnConditionalStyle={position:'fixed', transition: 'width 1s cubic-bezier(0.46, 0.03, 0.52, 0.96) 0.5s', left:openDrawer?(330-(pinIconSize/2))+'px':(68-(pinIconSize/2))+'px',top:'70vh'};


  // ITEMS.push(
  //   <>
  //     {
  //       <div >
  //         < span style={{
  //           height: "40px",
  //           display: "flex",
  //           alignItems: "center",
  //           justifyContent: "center"
  //         }}>
  //             Data Model
  //         </span>

  //         < span style={{
  //           height: "40px",
  //           display: "flex",
  //           alignItems: "center",
  //           justifyContent: "center"
  //         }} >
  //             Interfaces
  //         </span>
          
  //       </div>
  //     }
  //   </>
  // );

  var conditionalStyling = {
    display: "none",
    transition: "width 0.25s ease-in-out",
    width: openDrawer ? "0px" : null,
    overflowX: 'hidden',
    paddingBottom: "10px"
  };

  const leftNavigationHeight = useRef(0);
   let  appformId = window.activeScreen;
  
  
  useEffect(() => {
    const height = document
      .querySelector("#leftNavigation_sideBySide")
      ?.getBoundingClientRect()?.top;
    leftNavigationHeight.current = height;
  }, []);

  const handlePinned = (evt) => {
    const isChevron = evt.target.closest("#faChevronCircleID");
    if (!isChevron) {
      setPinned(!pinned);
    } else {
      window.changeDrawer("open")
      setSelectedMenuItemState(getRequiredView("Controls"));
    }
};

  return (
    <ClickAwayListener
      mouseEvent="onMouseDown"
      touchEvent="onTouchStart"
      onClickAway={(e) => {
      if (paneOpened) {  
      handleClickAway(e);
      }
}}
    >
      <div
        id="leftNavigation_id_main"
        className="leftNavigation_className_main"
        role="region"
        aria-label="Left Navigation"
      >

<div
          className={style.pinIconDiv}
          style={{...
            pinBtnConditionalStyle,
            left:paneOpened ? `${pinIconPlace -10}px` : pinBtnConditionalStyle.left
          }}
          id={"pinBtnConditionalStyle_id"}
        >
          <Tooltip
            aria-label={
              !paneOpened
                ? t(`translation:${"Expand_Controls"}`)
                : !pinned
                ? t(`translation:${"Pin_Controls"}`)
                : t(`translation:${"Unpin_Controls"}`)
            }
            title={
              !paneOpened
                ? t(`translation:${"Expand_Controls"}`)
                : !pinned
                ? t(`translation:${"Pin_Controls"}`)
                : t(`translation:${"Unpin_Controls"}`)
            }
            classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
            placement={"bottom-start"}
            arrow
          >
          <IconButton
            onClick={(e) => handlePinned(e)}
            // onKeyDown={togglePinning}
            className={style.pinBtn}
          >
            {
              !paneOpened
            ?
              <FontAwesomeIcon
                id="faChevronCircleID"
                key={"faChevronCircle"}
                icon={faChevronCircleRight}
                // className={drawerPinned? style.drawerBtnActive : style.drawerBtnInActive}
                style={pinIconStyle}
              />
            :
            [!pinned 
            ?  
              <img
                src={require("../../Icons/Pinning_icon.svg").default}
                height="24"
                style={{border:"1px solid #c4c4c4", borderRadius:"50px"}}
                alt="Pin Icon"
              />
            :
              <img
                src={require("../../Icons/Pinning_blue_icon.svg").default}
                height="24"
                alt="Pin Icon"
              />
            ]}
            </IconButton>
          </Tooltip>
        </div>

        <Drawer
          anchor={anchor}
          open={openDrawer}
          // onClose={toggleDrawer(anchor, "off")}
          // onOpen={toggleDrawer(anchor, "on")}
          variant={variant}
          className={`${style.expandableDrawer} ${classes.expandableDrawer} formBuilder_main_app`}
          classes={{ paper: classes.paper }}
          id="leftNavigation_sideBySide"
          style={{ boxShadow: "3px 3px 6px #00000029" }}
        >
          {
            <SearchControl
              width={"288px"}
              style={style.searchBar}
              collapsed={!openDrawer}
              collapsedWidth={"0px"}
              on_click={(e, anchor, on = "on", itemName) => toggleDrawer(e, anchor, "on", itemName)}
              on_keyDown={(e, anchor, on = "on", itemName) => toggleDrawer(e, anchor, "on", itemName)}
              setSearch={setSearch}
              search={search}
              textRef={textInput}
              anchor={anchor}
              selectedMenuItemNameState={selectedMenuItemNameState}
              openedFromLeftNav = {true}
            />
          }
          <div
            id="iforms_leftNav_sideBySide"
            className={style.sideBySide}
            style={{
              height: appformId=== "forms" ? `calc( calc( var(--app-height-form) * 0.98) - ${leftNavigationHeight.current + 50}px )` : appformId=== "applications" ?  `calc( var(--app-height-form) - ${leftNavigationHeight.current + 50}px )`: `calc( calc( var(--app-height-form) * 0.98) - ${leftNavigationHeight.current + 50}px )`,
            }}
          >
            <div
              // className={openDrawer?style.menuItemsContainer:null}
              className={style.menuItemsContainer}
              style={{overflowX:"hidden"}}
            >
              {ITEMS}
            </div>

            <div
              id="leftNavigation_container"
              className={style.viewWrapper}
              style={conditionalStyling}
              tabIndex="0"
              onKeyDown={(e) => handleEscapeKey(e)}
            >
              {selectedMenuItemState}
            </div>
          </div>
        </Drawer>
      </div>

      {/* <div className={style.LeftNavigation}>
                <BasicControls setDragging={props.setDragging} handleDragging={props.handleDragging} createNewElement={props.createNewElement} on_drag={props.on_drag} formData={props.formData} selectedControl={props.selectedControl} showProperties={props.showProperties} hideProperties={props.hideProperties} applyChanges={(ev,saveOldObject)=>props.applyChanges(ev,saveOldObject)} changeUndoList={()=>props.changeUndoList()}  unDo={props.undo} handleUndo={props.handleUndo} handleRedo={props.handleRedo} reDo={props.redo}/>
        </div> */}
    </ClickAwayListener>
  );
};

export default LeftNavigation;
